import styled from 'styled-components';
import {
  FilterType,
  ItemStatusData,
  RightStatusData,
  LesseeStatusData,
  FormalAuctionData,
  PtypeItemStatusData,
  PTypeRightStatusData,
  PTypeLesseeStatusData,
} from '../FilterData';
interface Props {
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
  type?: string;
}

const SpecailCondition = ({ filters, setFilters, type }: Props) => {
  const allSelected1 = ItemStatusData.every((item) =>
    filters.multiSpecialItemCondition.includes(item.name),
  );
  const allSelected2 = RightStatusData.every((item) =>
    filters.multiSpecialItemCondition.includes(item.name),
  );
  const allSelected3 = LesseeStatusData.every((item) =>
    filters.multiSpecialItemCondition.includes(item.name),
  );
  const allSelected4 = FormalAuctionData.every((item) =>
    filters.multiSpecialItemCondition.includes(item.name),
  );
  const isSelectedAllOptions =
    allSelected1 && allSelected2 && allSelected3 && allSelected4;

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,
      specialItemCondition: [],
      multiSpecialItemCondition: filters.multiSpecialItemCondition.includes(
        value,
      )
        ? filters.multiSpecialItemCondition.filter((v) => v !== value)
        : [...filters.multiSpecialItemCondition, value],
    });
  };
  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        specialItemCondition: [],
        multiSpecialItemCondition: filters.multiSpecialItemCondition.filter(
          (name) => !data.some((item) => item.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,
        specialItemCondition: [],
        multiSpecialItemCondition: Array.from(
          new Set([
            ...filters.multiSpecialItemCondition,
            ...data.map((item) => item.name),
          ]),
        ),
      });
    }
  };

  const handleSpecialConditionChange = (value: string) => {
    setFilters({
      ...filters,
      specialConditionViewOption: value,
    });
  };

  return (
    <AllOptionBox>
      <AllOptionBoxContent>
        <ViewOption>
          <span>보기옵션</span>
          <ViewOptionInputBox>
            {[
              { value: 'a', label: '모두 해당' },
              { value: 'o', label: '1개 이상 포함' },
              { value: 'n', label: '해당 없음' },
            ].map((option) => (
              <ViewOptionInputItem key={option.value}>
                <input
                  type="radio"
                  name="specialCondition"
                  value={option.value}
                  checked={filters.specialConditionViewOption === option.value}
                  onChange={() => handleSpecialConditionChange(option.value)}
                />
                <span>{option.label}</span>
              </ViewOptionInputItem>
            ))}
          </ViewOptionInputBox>
          <Description>
            {filters.specialConditionViewOption === 'a'
              ? '선택한 조건이 모두 해당하는 물건을 검색합니다.'
              : filters.specialConditionViewOption === 'o'
                ? '선택한 조건을 1개 이상 포함하는 물건을 검색합니다.'
                : '선택한 조건에 해당되지않는 물건을 검색합니다.'}
          </Description>
          <OptionItem
            onClick={() => {
              if (isSelectedAllOptions) {
                setFilters({
                  ...filters,
                  multiSpecialItemCondition: [],
                });
              } else {
                toggleAllSelect(isSelectedAllOptions, [
                  ...ItemStatusData,
                  ...RightStatusData,
                  ...LesseeStatusData,
                  ...FormalAuctionData,
                ]);
              }
            }}
          >
            <img
              src={`/assets/images/check/${isSelectedAllOptions ? 'check-blue-on' : 'check-blue-off'}.svg`}
              alt="Check"
            />
            <span>전체선택</span>
          </OptionItem>
        </ViewOption>

        <Block>
          <BlockTitle>물건현황</BlockTitle>
          <BlockContent>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected1, ItemStatusData);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>물건현황 전체</span>
            </OptionItem>
            {(type === 'p' ? PtypeItemStatusData : ItemStatusData).map(
              (item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.name);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiSpecialItemCondition.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ),
            )}
          </BlockContent>
        </Block>
        <Block>
          <BlockTitle>권리</BlockTitle>
          <BlockContent>
            <OptionItem
              onClick={() => {
                toggleAllSelect(allSelected2, RightStatusData);
              }}
            >
              <img
                src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>권리 전체</span>
            </OptionItem>
            {(type === 'p' ? PTypeRightStatusData : RightStatusData).map(
              (item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.name);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiSpecialItemCondition.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ),
            )}
          </BlockContent>
        </Block>
        <Block>
          <BlockTitle>임차인</BlockTitle>
          <BlockContent>
            {type !== 'p' && (
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected3, LesseeStatusData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>임차인 전체</span>
              </OptionItem>
            )}

            {(type === 'p' ? PTypeLesseeStatusData : LesseeStatusData).map(
              (item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.name);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiSpecialItemCondition.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ),
            )}
          </BlockContent>
        </Block>
        {type !== 'p' && (
          <Block>
            <BlockTitle>형식적경매</BlockTitle>
            <BlockContent>
              <OptionItem
                onClick={() => {
                  toggleAllSelect(allSelected4, FormalAuctionData);
                }}
              >
                <img
                  src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>형식적경매 전체</span>
              </OptionItem>
              {FormalAuctionData.map((item: any, index: number) => (
                <OptionItem
                  key={index}
                  onClick={() => {
                    toggleFilter(item.name);
                  }}
                >
                  <img
                    src={`/assets/images/check/${filters.multiSpecialItemCondition.includes(item.value) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>{item.name}</span>
                </OptionItem>
              ))}
            </BlockContent>
          </Block>
        )}
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};

export default SpecailCondition;

const AllOptionBox = styled.div`
  width: 100%;
  margin-top: 2px;
  border: 1px solid #e1e2e4;
  border-radius: 8px;
`;
const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ViewOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: #222;
  padding: 12px;
  border-bottom: 1px solid #e1e2e4;
`;
const ViewOptionInputBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  white-space: nowrap;
`;
const ViewOptionInputItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #171e26;
  cursor: pointer;
`;
const Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
`;
const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: rgba(23, 30, 38, 0.78);
  padding: 12px;
  border-bottom: 1px solid #e1e2e4;
`;
const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #222;
`;
const BlockContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;
const OptionItem = styled.div`
  display: flex;
  width: calc((100% - 12px) / 2);
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  border-radius: 4px;
  gap: 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
  white-space: wrap;
`;
